import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sqxbonds-UI/apps/src/components/screenerComponents/ScreenerNavbar.tsx");
